/* Diente — wishlist stored in localStorage (no app dependency). */
(function () {
  'use strict';

  var KEY = 'im_wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (error) {
      /* private mode / quota — the UI still updates for this page view */
    }
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  }

  function toggle(handle) {
    var list = read();
    var index = list.indexOf(handle);
    if (index > -1) list.splice(index, 1);
    else list.push(handle);
    write(list);
    return index === -1;
  }

  function paint() {
    var list = read();

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var active = list.indexOf(button.getAttribute('data-wishlist-handle')) > -1;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        active ? window.theme.strings.inWishlist : window.theme.strings.addToWishlist
      );
      /* The filled state is drawn in CSS from aria-pressed, so the SVG icon
         rendered by snippets/icon.liquid is never replaced here. */

      var label = button.querySelector('[data-wishlist-label]');
      if (label) {
        label.textContent = active
          ? window.theme.strings.inWishlist
          : window.theme.strings.addToWishlist;
      }
    });

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();

    toggle(button.getAttribute('data-wishlist-handle'));
    paint();
  });

  document.addEventListener('DOMContentLoaded', paint);
  document.addEventListener('wishlist:render', paint);
  // Re-paint cards injected after load (quick view, drawer, filter swaps).
  document.addEventListener('cart:updated', paint);

  window.DienteWishlist = { read: read, toggle: toggle, paint: paint };
})();